"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectStylesheet = void 0;
var _string = require("./string");
var injectStylesheet = function injectStylesheet(url, id) {
  // Check if the stylesheet has already been added
  id = id || (0, _string.getHash)(url);
  if (!document.getElementById(id)) {
    // Create a new link element
    var link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = url;
    // Add the link element to the head of the document
    document.head.appendChild(link);
  }
};
exports.injectStylesheet = injectStylesheet;